<template>
  <div class="view-tasklists" style="background-color: #CCC;">
  <header>
    <div class="mobile-header fixed-top">
      <div class="float-left">
        <img class="w-60 mt1" src="@/assets/MM-logo.png" alt="MentorMentee" @click="logoTapRedirect">

      </div>
      <div class="float-right">
        &nbsp;
      </div>
    </div>
  </header>
    <div class="wrapper" style="width: 70% !important; margin: 0 auto;">
        <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <div class="col-8 p-0 float-left">
              <h3 class="d-inline heading">Assessment Section: {{ assessment_title }}</h3>
            </div>
            <div class="col-4 p-0 float-right text-align-right">
              <button type="submit" class="btn btn-primary btn-md start-button" v-on:click="isModalVisible = true;">Answer Scale</button> 
            </div>
            <div style="clear: both"></div>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div v-show="loading" class="loading_show">
            <div class="spinner-border text-danger" style="color: #00ACEE !important;"></div>
            <div v-show="complete_loading" class="assessment_results_loading">Preparing Your Assessment Results</div>
          </div>
          <div class="preview-section text-align-center" v-if="loading == false && question_obj.questions.length == 0" style="background:none">
            No Questions to display
          </div>
          <div class="preview-section" v-if="loading == false && question_obj.questions.length > 0" >
            <div class="question-display counter_group-list">
              <div v-for="(question, qindex) in question_obj.questions" :key="qindex">
                <div :class="question.error == 1 ? 'error-border' : ''">
                  <div class="question-text">
                    <span class="counter_group-list__counter1">{{ getSerialNumber(qindex) }}</span>
                    {{ question.text }}
                  </div>
                  <div class="question-option">
                    <div class="float-left override-padding text-align-center" :class="questionClass" v-for="(scale_val, index) in question.section_scale" :key="qindex + '-' + index">
                      <div class="radio-button">
                        <input type="radio" :name="'questions-' + qindex"
                        :value="scale_val.value" :checked="scale_val.checked" :key="qindex + '-' + index + '-' + scale_val.value" v-on:click="getAnswersSelected(qindex, index, $event)">
                      </div>
                      <div class="radio-label">
                        <label >{{ scale_val.text }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="question.error == 1" class="error-text">
                  * Answer Required
                </div>
                <div style="clear: both"></div>
              </div>
            </div>
            <div class="col-12" style="padding-left: 0;" v-if="indexVal == 0 && scaleIds.length == 1">
              <div class="col-lg-6 padding-lr-5 float-left text-align-left" v-if="this.currentPage > 1">
                <button
                  v-on:click="goToPage('Previous')"
                  class="btn btn-white col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                  >Previous</button>
              </div>
              <div :class="'padding-lr-5 ' + getCompleteAssessmentDivClass" v-if="isShowContinueBtn">
                <button
                  v-on:click="onSubmit('Completed')"
                  :class="'btn btn-red padding-lr-5 ' + getCompleteAssessmentBtnClass"
                  style="height: 30px;border-radius: 10px; margin-top: 2px;font-weight: bold;padding-top: 3px;">Complete Assessment</button>
              </div>
              <div class="col-lg-6 padding-lr-5 float-right text-align-right" v-if="question_obj.totalQuestions > this.pageLimit && isPagination">
                <button v-if="this.currentPage != this.lastPage"
                  v-on:click="goToPage('Next')"
                  class="btn btn-white col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                  >Next</button>
              </div>
              <div style="clear: both; margin-bottom: 25px;"></div>

            </div>

            <div class="col-12" style="padding-left: 0;" v-if="indexVal == 0 && scaleIds.length > 1">
              <div class="col-lg-6 padding-lr-5 float-left text-align-left" v-if="this.currentPage > 1">
                <button
                  v-on:click="goToPage('Previous')"
                  class="btn btn-white col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                  >Previous</button>
              </div>
              <div :class="'padding-lr-5' + getCompleteAssessmentDivClass" v-if="isShowContinueBtn">
                <button
                  v-on:click="onSubmit('Inprogress')"
                  :class="'btn btn-red padding-lr-5' + getCompleteAssessmentBtnClass"
                  style="height: 30px;border-radius: 10px; margin-top: 2px;font-weight: bold;padding-top: 3px;">Continue</button>
              </div>
              <div class="col-lg-6 padding-lr-5 float-right text-align-right" v-if="indexVal == 0 && question_obj.totalQuestions > this.pageLimit && isPagination">
                <button v-if="this.currentPage != this.lastPage"
                  v-on:click="goToPage('Next')"
                  class="btn btn-white col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                  >Next</button>
              </div>
              <div style="clear: both; margin-bottom: 25px;"></div>

            </div>



            <div class="col-12 p-0" style="margin-top: 4rem !important;">
              <div class="col-lg-6 padding-lr-5 float-right text-align-right" style="padding-right: 0;" v-if="indexVal > 0 && (indexVal < parseInt(scaleIds.length - 1)) && isShowContinueBtn">
                <button
                  v-on:click="onSubmit('Inprogress')"
                  class="btn btn-red col-8 padding-lr-5"
                  style="height: 30px;border-radius: 10px; margin-top: 2px;font-weight: bold; padding-top: 1px;">Continue</button>
              </div>
              <div class="col-lg-6 padding-lr-5 float-right text-align-right" style="padding-right: 0;" v-if="indexVal > 0 && (indexVal == parseInt(scaleIds.length - 1)) && isShowContinueBtn">
                <button
                  v-on:click="onSubmit('Completed')"
                  class="btn btn-red col-10 padding-lr-5"
                  style="height: 30px;border-radius: 10px; margin-top: 2px;font-weight: bold;">Complete Assessment</button>
              </div>
              <div class="col-lg-6 padding-lr-5 float-left text-align-left" v-if="indexVal > 0 && scaleIds.length > 1">
                <button
                  v-on:click="goToPage('Previous')"
                  class="btn btn-white col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                  >Previous</button>
              </div>
              <div class="col-lg-6 padding-lr-5 float-right text-align-right" v-if="indexVal > 0 && question_obj.totalQuestions > this.pageLimit && isPagination">
                <button v-if="this.currentPage != this.lastPage"
                  v-on:click="goToPage('Next')"
                  class="btn btn-white col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                  >Next</button>
              </div>
              <div style="clear: both; margin-bottom: 25px;"></div>

            </div>



          </div>

        </div>
        </div>
    </div>


    <AnswerScale :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"></div>
      <div slot="body">
              <div class="col-12 p-0 text-align-center" style="margin: 5px 5px 30px 5px;">
                <div class="answer_scale">
                  <div class="answer-scale-heading">Answer Scale</div>
                  <div class="answer-scale-text" v-if="question_obj.section.scale == 1">
                    <div >1 - Disagree</div>
                    <div >2 - Neutral</div>
                    <div >3 - Agree</div>
                  </div>
                  <div class="answer-scale-text" v-if="question_obj.section.scale == 2">
                    <div >1 - Strongly Disagree</div>
                    <div >2 - Disagree</div>
                    <div >3 - Neutral</div>
                    <div >4 - Agree</div>
                    <div >5 - Strongly Agree</div>
                  </div>
                  <div class="answer-scale-text" v-if="question_obj.section.scale == 3">
                    <div >1 - Very Strongly Disagree</div>
                    <div >2 - Strongly Disagree</div>
                    <div >3 - Disagree</div>
                    <div >4 - Neutral</div>
                    <div >5 - Agree</div>
                    <div >6 - Strongly Agree</div>
                    <div >7 - Very Strongly Agree</div>
                  </div>
                </div>
              <button
                v-on:click="isModalVisible = false"
                class="btn btn-white col-6 override-padding" style="margin-top: 20px; height: 30px; border-radius: 10px; font-weight: bold;"
                >Return</button>
              </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </AnswerScale>



  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import GoBack from './shared/goback.vue';
import axios from 'axios';
import { store } from '../store/store';
import router from '../router/index.js';
import AnswerScale from './mentee/answer-scale-modal.vue';

export default {
        data() {
          return {
            assessmentId: '',
            assessmentAttemptId: '',
            indexVal: 0,
            sectionIds: [],
            question_obj: {
              questions: [],
              section: [],
              allQuestions: [],
              totalQuestions: 0,
            },
            loading: false,
            complete_loading: false,
            assessment_title: '',
            isModalVisible: false,
            admin: false,
            questionClass: 'custom-col-3',
            currentPage: 1,
            lastPage: 0,
            isShowContinueBtn: false,
            isPagination: false,
            pageLimit: 10,
            scaleIds:[],
          }
        },

        components: {
          GoBack,
          AnswerScale,
        },
        computed: {
          getCompleteAssessmentDivClass() {
            if (this.isPagination) {
              return 'col-lg-6 float-right text-align-right';
            } else {
              return 'col-lg-12 text-align-center';
            }
          },
          getCompleteAssessmentBtnClass() {
            if (this.isPagination) {
              return 'col-12';
            } else {
              return 'col-6';
            }
          }
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            logoTapRedirect: function() {
              router.push('/');
            },
            getAnswersSelected: function(qindex, index, event) {
              if(event.returnValue == true) {
                var selected_val = this.question_obj.questions[qindex].section_scale[index].value;
                for(var i=0; i<this.question_obj.questions[qindex].section_scale.length; i++) {
                  this.question_obj.questions[qindex].section_scale[i].checked = false;
                  if (this.question_obj.totalQuestions > this.pageLimit) {
                    this.question_obj.allQuestions[this.currentPage][qindex].section_scale[i].checked = false;
                  }
                }
                if(this.question_obj.questions[qindex].update == true) {
                  this.question_obj.questions[qindex].modified = true;
                  if (this.question_obj.totalQuestions > this.pageLimit) {
                    this.question_obj.allQuestions[this.currentPage][qindex].modified = true;
                  }
                }
                else {
                  this.question_obj.questions[qindex].insert = true;
                  if (this.question_obj.totalQuestions > this.pageLimit) {
                    this.question_obj.allQuestions[this.currentPage][qindex].insert = true;
                  }
                }
                this.question_obj.questions[qindex].section_scale[index].checked = true;
                this.question_obj.questions[qindex].error = 0;
                this.question_obj.questions[qindex].value = selected_val;
                if (this.question_obj.totalQuestions > this.pageLimit) {
                  this.question_obj.allQuestions[this.currentPage][qindex].section_scale[index].checked = true;
                  this.question_obj.allQuestions[this.currentPage][qindex].error = 0;
                  this.question_obj.allQuestions[this.currentPage][qindex].value = selected_val;
                }
              }
            },
            doValidate() {
              var flag = 0;
              for(var i=0; i<this.question_obj.questions.length; i++) {
                if(this.question_obj.questions[i].value == '') {
                  this.question_obj.questions[i].error = 1;
                  flag = 1;
                }    
              }
              return flag;
            },
            onSubmit: function(status) {
              var flag = this.doValidate();
              if(status == 'Completed') {
                this.complete_loading = true;
              }
              if(flag == 0) {
                this.loading = true;
                var scaleId = this.scaleIds[this.indexVal];
                axios('/custom/mentor-assessment-section-questions-answers-new/' + this.token + '/' + this.assessmentAttemptId,
                {
                  method: 'POST',
                  data: {
                    question_obj: this.question_obj,
                    status: status,
                  },
                })
                .then(() => {
                  if(status == 'Completed') {
                    this.flash({ message: 'Assessment completed successfully', variant: 'success' });
                    router.push("/mentor-assessment-report/" + this.token + '/' + this.assessmentAttemptId);
                  }
                  else {
                    this.onPrevNext('Next');
                  }
                })
                .catch(() => {

                });

                
              }

            },
            onPrevNext(val) {
              this.currentPage = 1;
              this.lastPage = 1;
              if(val == 'Previous') {
                this.indexVal -= 1;
              }
              else if(val == 'Next') {
                this.indexVal += 1;
              }
              this.getSectionQuestionsLists();
            },
            getScaleLists: function() {
              this.loading = true;
              axios.get('/custom/mentor-assessment-scale-lists-preview/' + this.token)
                .then((resp) => {

                    this.scaleIds = resp.data;
                    if(this.scaleIds.length > 0) {
                      this.getSectionQuestionsLists();
                    }
                    else {
                      this.loading = false;
                    }
                    
                })
                .catch(error => {

                });
            },
            getSectionQuestionsLists: function() {
              this.loading = true;
              var scaleId = this.scaleIds[this.indexVal];
              if(scaleId) {
                  axios.get('/custom/mentor-assessment-section-questions-lists-preview-new/' + scaleId + '/' + this.token, {
                  params: {
                    attempt_id: this.assessmentAttemptId,
                  }
                  })
                  .then((resp) => {
                      this.loading = false;
                      if(scaleId == 2) {
                        this.questionClass = 'custom-col-2';
                      }
                      else if(scaleId == 3) {
                        this.questionClass = 'custom-col-1';
                      }
                      this.question_obj.totalQuestions = resp.data.questions.length;
                      if (resp.data.questions.length > this.pageLimit) {
                        this.question_obj.questions = resp.data.questions.slice(0, this.pageLimit);
                        this.currentPage = 1;
                        this.lastPage = Math.ceil(resp.data.questions.length/this.pageLimit);
                        for (var m = 1; m <= this.lastPage; m++) {
                          var startVal = 0;
                          var endVal = this.pageLimit;
                          var lastEndVal;
                          if (m == 1) {
                            startVal = 0;
                            endVal = endVal*1;
                          } else {
                            startVal = lastEndVal;
                            endVal = endVal*m;
                          }
                          lastEndVal = endVal;
                          // console.log(startVal + " >> " + endVal)
                          this.question_obj.allQuestions[m] = resp.data.questions.slice(startVal, endVal);
                        }
                        this.isShowContinueBtn = false;
                        this.isPagination = true;
                      } else {
                        this.question_obj.questions = resp.data.questions;  
                        this.isPagination = false;
                        this.isShowContinueBtn = true;
                      }
                      this.question_obj.section = resp.data.section;
                  })
                  .catch(error => {

                  });

              }

            },
            goToPage: function(val) {
              var flag = 1;
              if(val == 'Previous') {
                if (this.currentPage == 1) {
                  this.onPrevNext('Previous');
                } else {
                  this.currentPage -= 1;
                  if (this.currentPage == this.lastPage) {
                    this.isShowContinueBtn = true;
                  } else {
                    this.isShowContinueBtn = false;
                  }
                  if (this.question_obj.totalQuestions > this.pageLimit) {
                    this.question_obj.questions = this.question_obj.allQuestions[this.currentPage];
                  }
                }
              } else {
                if(val == 'Next') {
                  flag = this.doValidate();
                  if(flag == 0) {
                    this.loading = true;
                    var scaleId = this.scaleIds[this.indexVal];
                    axios('/custom/mentor-assessment-section-questions-answers-new/' + this.token + '/' + this.assessmentAttemptId,
                    {
                      method: 'POST',
                      data: {
                        question_obj: this.question_obj,
                        status: status,
                      },
                    })
                    .then(() => {
                      for(var i=0; i<this.question_obj.questions.length; i++) {
                        this.question_obj.questions[i].insert = false;
                        if (this.question_obj.totalQuestions > this.pageLimit) {
                          this.question_obj.allQuestions[this.currentPage][i].insert = false;
                        }
                      }                    
                      this.currentPage += 1;  
                      if (this.currentPage == this.lastPage) {
                        this.isShowContinueBtn = true;
                      } else {
                        this.isShowContinueBtn = false;
                      }
                      if (this.question_obj.totalQuestions > this.pageLimit) {
                        this.question_obj.questions = this.question_obj.allQuestions[this.currentPage];
                      }
                      this.loading = false;
                    })
                    .catch(() => {

                    });
                  }
                }
              }
            },
            getSerialNumber(num) {
              var num = num + 1;
              if (this.currentPage == 1) {
                return num + '. ';
              } else {
                return (num + (this.pageLimit * this.currentPage) - this.pageLimit) + '. ';
              }
            }
        },
        created() {
          this.token = this.$route.params.token;
          this.assessmentAttemptId = this.$route.params.assessmentAttemptId;
          this.getScaleLists();
          axios.get('/custom/mentor-assessment-section-title/' + this.token, {
          })
          .then(resp =>  {
            this.assessment_title = resp.data.assessmentTitle;
          })
          .catch(function(error) {
            console.log(error);
          });
        },

}

</script>

<style scoped>
.answer_scale {
  padding: 10px 20px 25px 30px;
  border: 1px solid #CCC;
  margin: 0;
  width: 100%;
  border-radius: 10px;
  font-family: 'Roboto Condensed', sans-serif;
}
.assessment_results_loading {
  padding-top: 30px;
  color: #EE4200;
  font-family: 'bebas-neue-pro', sans-serif;
}
.preview-section {
  width: 50%;
  margin: 0 auto;
  background-color: #FFF;
  border-radius: 10px;
  padding: 15px 10px
}
.counter_group-list {
  counter-reset: my-sec-counter2;
}
.counter_group-list__counter:after {
  counter-increment: my-sec-counter2;
  content: counter(my-sec-counter2) ". ";
}
.question-text {
  font-size: 13px;
  color: #555;
  padding: 10px 10px 10px 15px;
  background-color: #E9E9E9;
  border-radius: 15px;
  width: 100%;
  margin-bottom: 10px;
}
.question-display {
  margin-top: 5px;
  margin-bottom: 15px;
}
.question-option {
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  float: left;
  width: 100%;
}
.radio-label {
  padding-left: 3px;
  margin-top: -2px;
  font-size: 10px;
  color: #8C8C8C;
}
.error-border {
  border: 1px solid #FF0000;
  border-radius: 10px;
  float: left;
  width: 100%;
  padding: 5px;
}
.error-text {
  color: #FF0000;
  font-size: 11px;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: right;
}
.start-button {
    color: #00acee;
    background-color: #FFF;
    border: 1px solid #00acee;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 5px;
    line-height: 8px;
    width: 115px;
}

</style>
<style>
.answer-scale-heading {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 15px;
  font-family: 'Roboto Condensed', sans-serif;
}
.answer-scale-text {
  font-size: 16px;
  text-align: left;  
  font-family: 'Roboto Condensed', sans-serif;
}
.custom-col-1 {
  width: 14.11%;
}
.custom-col-2 {
  width: 19.66%; 
}
.custom-col-3 {
  width: 31.11%; 
}
.fa-chevron-left, .fa-chevron-right {
  font-size: 30px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/mentor_assessment_question_answer.vue